import { jsx as _jsx } from "react/jsx-runtime";
import { Button, getTestId, useBreakpoint } from '@airtel/air-design-system';
import { getListFooterStyles } from './PlanListFooterStyles';
export var PlanListFooter = props => {
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var listFooterStyles = getListFooterStyles(isLargeScreen);
  var _props$planListData = props.planListData,
    planListData = _props$planListData === void 0 ? [] : _props$planListData,
    _props$expandCtaData = props.expandCtaData,
    expandCtaData = _props$expandCtaData === void 0 ? {} : _props$expandCtaData,
    onUserAction = props.onUserAction,
    id = props.id,
    showFullList = props.showFullList,
    toggleShowFullList = props.toggleShowFullList;
  var _expandCtaData$initia = expandCtaData.initialItemCount,
    initialItemCount = _expandCtaData$initia === void 0 ? isLargeScreen ? 3 : 4 : _expandCtaData$initia,
    _expandCtaData$expand = expandCtaData.expandedCtaTitle,
    expandedCtaTitle = _expandCtaData$expand === void 0 ? (planListData === null || planListData === void 0 ? void 0 : planListData.length) - initialItemCount > 0 && (planListData === null || planListData === void 0 ? void 0 : planListData.length) - initialItemCount + " " + ((expandCtaData === null || expandCtaData === void 0 ? void 0 : expandCtaData.expandedCtaCustomTitle) || 'more plans') : _expandCtaData$expand,
    _expandCtaData$collap = expandCtaData.collapseCtaTitle,
    collapseCtaTitle = _expandCtaData$collap === void 0 ? 'view less' : _expandCtaData$collap,
    onViewMoreCtaPress = expandCtaData.onViewMoreCtaPress,
    _expandCtaData$should = expandCtaData.shouldToggle,
    shouldToggle = _expandCtaData$should === void 0 ? false : _expandCtaData$should,
    _expandCtaData$expand2 = expandCtaData.expandedIconName,
    expandedIconName = _expandCtaData$expand2 === void 0 ? shouldToggle ? 'DownChevronButtonIcon' : 'RightChevronButtonIcon' : _expandCtaData$expand2,
    _expandCtaData$collap2 = expandCtaData.collapseIconName,
    collapseIconName = _expandCtaData$collap2 === void 0 ? 'UpChevronButtonIcon' : _expandCtaData$collap2;
  var title = showFullList ? collapseCtaTitle ? collapseCtaTitle : '' : expandedCtaTitle;
  return _jsx(Button, Object.assign({
    buttonType: "tertiary",
    size: "md",
    version: "variable-width",
    iconPosition: "right",
    onPress: () => {
      onViewMoreCtaPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onViewMoreCtaPress), {
        item: Object.assign(Object.assign({}, props), {
          title: title
        })
      }));
      shouldToggle && toggleShowFullList();
    },
    style: listFooterStyles.viewMoreCta,
    title: title,
    iconName: showFullList ? collapseIconName : expandedIconName
  }, getTestId(props === null || props === void 0 ? void 0 : props.testID), expandCtaData === null || expandCtaData === void 0 ? void 0 : expandCtaData.accessibilityProps));
};